/** A deploy replaces every hashed asset, so a client still on the previous index.html asks for chunks that are gone — and each browser words that failure differently. */
export const STALE_DEPLOY_ERROR_PATTERNS = [
	'Failed to fetch dynamically imported module',
	'error loading dynamically imported module',
	'Importing a module script failed',
	'Unable to preload CSS for',
	'is not a valid JavaScript MIME type',
]

export function isStaleDeployError(error: unknown): boolean {
	const message = error instanceof Error ? error.message : String(error ?? '')

	return STALE_DEPLOY_ERROR_PATTERNS.some(pattern => message.includes(pattern))
}
